/**
 * Author: Gunjan
 *
 * Component: MotionBox
 * Description:
 * - Use `MotionBox` anywhere you'd use a `Box` component, with the added ability to apply
 *   Framer Motion animation props like `animate`, `initial`, and `transition`.
 */

import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

export default MotionBox;
